import { PerfilComponent } from './../perfil/perfil.component';
import { Form } from './../../models/form.model';
import { UserService } from 'src/app/services/user.service';
import { MatDialog } from 'node_modules/@angular/material/dialog';
import { Component } from '@angular/core';
import { trigger, transition, style, animate, query, stagger, animateChild } from "@angular/animations";
import { FormService } from 'src/app/services/form.service';
import { FormControl, Validators, FormGroup } from '@angular/forms';
import { OptionService } from 'src/app/services/options.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Store } from '@ngrx/store';
import * as FormActions from '../../reducers/actions/forms.actions';

import { GLOBAL } from 'src/app/services/global';
import { MesonOnlineComponent } from '../meson-online/meson-online.component';
import { MAT_SNACK_BAR_DATA, MatSnackBar } from '@angular/material/snack-bar';
import { AuxUrlComponent } from '../ventanasUrl/auxUrl/auxUrl.component';
import { AuxUrlCertComponent } from '../ventanasUrl/auxUrlCert/auxUrlCert.component';
import { AuxUrlBnupComponent } from '../ventanasUrl/auxUrlBnup/auxUrlBnup.component';
import { AuxUrlInfTerComponent } from '../ventanasUrl/aux-url-inf-ter/aux-url-inf-ter.component';
import { AuxUrlInspeccionComponent } from '../ventanasUrl/aux-url-inspeccion/aux-url-inspeccion.component';
import { AuxTotemComponent } from '../ventanasUrl/auxTotem/auxTotem.component';
import { CookieService } from 'ngx-cookie-service';
import { ClaveUnicaService } from 'src/app/services/clave_unica.service';

interface AppState {
  form: Form;
}
@Component({
  selector: 'page-inicio',
  templateUrl: './inicio.component.html',
  styleUrls: ['./inicio.component.scss'],
  providers: [FormService, OptionService, UserService, ClaveUnicaService],
  animations: [
    trigger('items', [
      transition(':enter', [
        style({ transform: 'scale(0.5)', opacity: 0 }),  // initial
        animate('1.2s cubic-bezier(.8, -0.6, 0.26, 1.6)',
          style({ transform: 'scale(1)', opacity: 1 }))  // final
      ]),
      transition(':leave', [
        style({ transform: 'scale(1)', opacity: 1, height: '*' }),
        animate('0.6s cubic-bezier(.8, -0.6, 0.2, 1.5)',
          style({
            transform: 'scale(0.5)', opacity: 0,
            height: '0px', margin: '0px'
          }))
      ])
    ]),
    trigger('list', [
      transition(':enter', [
        query('@items', stagger(150, animateChild()))
      ]),
    ])
  ]
})


export class InicioComponent {

  public form;
  matcher = new FormService();
  options = [];
  inputBuscar;
  identity;
  token;
  public footer = GLOBAL.footer;
  public web = GLOBAL.web;
  public webUrl = GLOBAL.webUrl;
  public nombreMuni = GLOBAL.nombreMuni;
  public contActivos = 0;

  public pagoLinea = ["Certificado de Número", "Certificado de Afectación a Utilidad Pública (No Expropiación)", "Certificado de Informes Previos", "Certificado de Localización", "Acreditación de Recepción Final", "Acreditación de Vivienda Económica acogida a D.F.L.2", "Acreditación de Vivienda Social"]
  public espedienteLinea = ["Ingreso de expedientes (no disponible)", "Seguimiento de expedientes"]
  public pagoRetiro = ["Copia de documentos y planos aprobados", "Constancia de Expediente en Trámite", "Resolución para acoger una vivienda al DFL 2 de 1959", "Calificación y Valorización"]
  public noticias = ["Revisión y descarga de documentos informátivos emitidos por la DOM."]

  constructor(private _optionService: OptionService, private dialog: MatDialog,
    private _userService: UserService, private snackBar: MatSnackBar,
    private spinner: NgxSpinnerService, private store: Store<AppState>, private route: ActivatedRoute, private _router: Router, private cookieService: CookieService, private claveUnicaService: ClaveUnicaService) {


    this.cookieService.delete('sessionid');

    this.store.dispatch(new FormActions.FormUpdate('0', ''))
    localStorage.clear();
    sessionStorage.removeItem('borrador');
    this.form = new FormGroup({
      buscar: new FormControl('', Validators.required)
    })
    this.identity = this._userService.getIdentity();
    this.token = this._userService.getToken();
    if (this.route.snapshot.paramMap.get("token")) {
      this._userService.activeUser(this.route.snapshot.paramMap.get("token")).subscribe(
        response => {
          console.log('cuenta activada, response', response)
          if (response.active) {
            alert("Cuenta activada");
          }
        },
        error => {
          let e = JSON.parse(error._body);
          alert(e.message);
        }
      )
    }


    this.spinner.show();

    this._optionService.getServices().subscribe(
      response => {
        this.options = response;
        for (let i = 0; i < response.length; i++) {
          if (response[i].active && (this.nombreMuni == 'Prueba Solnet' ? (response[i].name == 'Expedientes' ? true : false) : true))
            this.contActivos++;
        }
        //console.log(response);
        this.spinner.hide();
      },
      error => {
        console.log(error);
        this.spinner.hide();

        console.log("Verifique la conexión a internet.")
      }
    )


  }

  /* NO BORRAR, 
    sign(active?, url?){
      console.log(active)
      if(active == true){
        if(sessionStorage.getItem("identity-domCloud") && sessionStorage.getItem("token-domCloud")){
          this.dialog.closeAll();
          this._router.navigate([`/${url}`]);
  
        }else{
          localStorage.setItem("navdomcloud", url)
          this.dialog.open(HomeComponent,{
            data: {
              url: url
            }
          })
        }
      } else {
        this.snackBar.open("Opción deshabilitada", "Cerrar", {
          duration: 3000,
        });
      }
    }
  */

  /**BORRAR CUANDO YA TRASPASEN TODAS LAS PLATAFORMAS A ANGULAR. */
  sign(active?, url?) {
    if (active == true && url == 'expedientes') {


      // this._router.navigate([`aux/expediente`]);
      this.dialog.open(AuxUrlComponent, {
        data: {
          url: url
        }
      })
      // window.open(`${GLOBAL.seguimientoSolicitudes}`, "_blank")

    } else if (active) {
      switch (url) {
        case 'certificados':
          this.dialog.open(AuxUrlCertComponent, {
            data: {
              url: url
            }
          })
          break;
        case 'BNUP':
          this.dialog.open(AuxUrlBnupComponent, {
            data: {
              url: url
            }
          })
          break;
        case 'inspeccion':
          this.dialog.open(AuxUrlInspeccionComponent, {
            data: {
              url: url
            }
          })
          break;

        case 'informacion':
          this.dialog.open(AuxUrlInfTerComponent, {
            data: {
              url: url
            }
          })
          break;
        case 'atencion':
          this.dialog.open(MesonOnlineComponent, {
            data: {
              url: url
            }
          })
          break;
        case 'totem':
          console.log("entro a mostrar totem");

          this.dialog.open(AuxTotemComponent, {
            data: {
              url: url
            }
          })
          break;
        //window.open(´${GLOBAL.totemUrl}´, "_blank")
        //break;
        case 'vivienda':
          this._router.navigate([`aux/vivienda`]);
          /* this.dialog.open(AuxCertSinPComponent, {
            data: {
              url: url
            }
          }) */
          break;

        case 'noticias':
          this._router.navigate([`aux/documentos`]);
          /* this.dialog.open(AuxCertSinPComponent, {
            data: {
              url: url
            }
          }) */
          break;
      }
    }
  }

  ngDoCheck() {

    this.identity = this._userService.getIdentity();
    this.token = this._userService.getToken();
  }

  async logout() {
    this.store.dispatch(new FormActions.FormUpdate('0', ''))
    sessionStorage.removeItem("identity-domCloud");
    sessionStorage.removeItem("token-domCloud");
    
    const response = await this.claveUnicaService.logoutClaveUnica()
    console.log('Deslogeo exitoso:', response);

  }
  openPerfil() {
    this.dialog.open(PerfilComponent)
  }

  getClassCardItem(name: string): string {
    let classCard = 'card-default';
    if (name.trim() == "Solicitudes con pagos en línea") {
      classCard = "card-certificados"
    }
    if (name.trim() == "Solicitud de Expedientes en línea") {
      classCard = "card-expedientes"
    }
    if (name.trim() == "Solicitudes con pagos al momento del retiro") {
      classCard = "card-vivienda"
    }

    return classCard;
  }

}